export const WEBSOCKET_SET_CONNECTION_STATE = 'services.websocket.set-connection-state';
export const WEBSOCKET_SET_ERROR_MESSAGE = 'services.websocket.set-error-message';
export const WEBSOCKET_ADD_LISTENER = 'services.websocket.add-listener';
export const WEBSOCKET_REMOVE_LISTENER = 'services.websocket.remove-listener';
